import { BLANK_INVISIBLE_SPACE_REGEX, BLANK_SPACE_REGEX } from 'core/constants/regex.constant';

const bytesToBase64 = (bytes: Uint8Array) => {
  const binString = String.fromCodePoint(...bytes);
  return btoa(binString);
};

export const stringToBase64 = (str: string) => bytesToBase64(new TextEncoder().encode(str));

export const clearEmptySpaces = (str: string) =>
  str.replace(BLANK_INVISIBLE_SPACE_REGEX, '').replace(BLANK_SPACE_REGEX, ' ').trim();
